import 'css-chunksrc/client/pages/costProfilesPage/toolbar/styles.scss';export default {
  "toolbar": "_toolbar_7hskr_1",
  "filter": "_filter_7hskr_11",
  "title": "_title_7hskr_19"
};